import type { LucideIcon } from 'lucide-react';
import type { Kpi } from '@shared/types';
import { Delta } from '@/components/ui';
import { cn } from '@/lib/cn';
import type { Tone } from '@/lib/status';
import { TONE_BADGE } from '@/lib/status';

/** Executive KPI tile: icon, signed delta, big value, label + note. */
export function KpiCard({
  kpi,
  icon: Icon,
  tone = 'primary',
  invert = false,
}: {
  kpi: Kpi;
  icon: LucideIcon;
  tone?: Tone;
  invert?: boolean;
}) {
  return (
    <div className="surface flex flex-col gap-3 p-4">
      <div className="flex items-start justify-between">
        <span className={cn('grid h-9 w-9 place-items-center rounded-lg border', TONE_BADGE[tone])}>
          <Icon className="h-[18px] w-[18px]" strokeWidth={2} />
        </span>
        {/* Sin período anterior no se muestra nada: un 0 con flecha se lee como una
            medición que dice "no cambió", y eso ya sería inventar un dato. */}
        {kpi.deltaPct != null && <Delta value={kpi.deltaPct} invert={invert} />}
      </div>
      <div>
        <p className="text-xs text-ink-muted">{kpi.label}</p>
        <p className="cifra mt-1 text-[32px] leading-none">{kpi.value}</p>
        <p className="mt-2 text-2xs text-ink-faint">
          <span className="text-ink-muted">{kpi.unit}</span>
          {kpi.note && <span> · {kpi.note}</span>}
        </p>
      </div>
    </div>
  );
}
